import React, { createContext, useContext } from "react";
import siteContent from "../lib/siteContent";

const ContentCtx = createContext(null);
export const useContent = () => useContext(ContentCtx);

// Static content provider — no backend calls.
export function ContentProvider({ children }) {
  return <ContentCtx.Provider value={{ content: siteContent }}>{children}</ContentCtx.Provider>;
}
